import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BlogPost } from '../services/api';
import useSEO from '../hooks/useSEO';
import SEOHead from '../components/SEOHead';
import Navbar1 from '../layout/Navbar1';

const BlogDetails: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { seoData } = useSEO();
  
  const [blog, setBlog] = useState<BlogPost | null>(
    location.state?.blog || null
  );

  useEffect(() => {
    if (!blog && id) {
      const fetchBlog = async () => {
        try {
          const response = await fetch(`https://rawasicrystal.com/api/blogs/`);
          const blogs = await response.json();
          const foundBlog = blogs.find((b: BlogPost) => b.id?.toString() === id || blogs.indexOf(b).toString() === id);
          if (foundBlog) {
            setBlog(foundBlog);
          }
        } catch (error) {
        
        }
      };
      fetchBlog();
    }
  }, [blog, id]);

  if (!blog) {
    return (
      <>
        <Navbar1 enableScrollEffect={false} className="bg-black" />
        <div className="container py-5" style={{marginTop: '130px'}}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">{t('common.loading') || 'جاري التحميل...'}</p>
          </div>
        </div>
      </>
    );
  }

  const blogSEOData = {
    ...seoData,
    meta_title: blog.title,
    meta_description: blog.content.slice(0, 160),
    canonical_url: `https://rawasicrystal.com/blogs/${id}`,
    og_title: blog.title,
    og_description: blog.content.slice(0, 160),
    og_image: blog.image,
    og_type: 'article',
    twitter_title: blog.title,
    twitter_description: blog.content.slice(0, 160),
    twitter_image: blog.image,
  };

  return (
    <>
      {blogSEOData && <SEOHead seoData={blogSEOData} />}
      <Navbar1 enableScrollEffect={false} className="bg-black" />
      <div className="container py-5" style={{marginTop: '130px'}}>
        <div className="mb-4">
          <RouterLink to="/blogs" className="btn btn-custom">
            ← {t('blog.backToList') || 'العودة للمدونة'}
          </RouterLink>
        </div>
        <div className="card mx-auto shadow-sm border-0" style={{maxWidth: '800px'}}>
          <img
            src={blog.image} 
            className="card-img-top"
            alt={blog.title} 
            style={{height: '400px', objectFit: 'cover'}}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
          <div className="card-body p-4">
            <h1 className="card-title mb-3 text-primary fw-bold">{blog.title}</h1>
            {blog.created_at && (
              <p className="text-muted mb-3">
                <small>
                  {new Date(blog.created_at).toLocaleDateString('ar-SA')}
                </small>
              </p>
            )}
            <div 
              className="card-text text-dark"
              style={{lineHeight: '1.8', fontSize: '1.1rem'}}
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails; 